<template>
  <v-card>
    <v-card-text class="d-flex flex-wrap space-between" style="gap: 24px">
      <div style="flex: 1">
        <span class="digital-voucher-title">{{ isProductsGroup ? 'Grupo de produtos da campanha' : 'Produtos da campanha' }}</span>
        <div class="d-flex flex-row justify-space-between align-end">
          <span class="desc">Produtos e suas quantidades que o consumidor deve ter na cesta para ter acesso ao voucher adicionado ao lado</span>
          <div v-if="isProductsGroup" class="d-flex flex-row align-center" style="gap: 6px">
            <span class="minimum-quantity-text">Quantidade mínima: {{ triggerAmount }}</span>
            <tooltip message="Quantidade mínima de produtos necessários dessa lista para ganhar o benefício. Os diferentes produtos somam entre si.">
              <mf-icon style="padding-top: 2px" small color="grey">info</mf-icon>
            </tooltip>
          </div>
        </div>
        <v-data-table class="mt-4" :headers="productHeaders" :items="products" :search="search" disable-sort disable-pagination hide-default-footer>
          <template v-slot:header.trigger_amount="{ header }">
            <tooltip message="Quantidade necessária do produto para ativar a oferta">
              {{ header.text }}
              <mf-icon small color="grey">info</mf-icon>
            </tooltip>
          </template>

          <!-- Removido temporariamente -->
          <!-- <template v-slot:item.status="{ item }">
            <tooltip :disabled="!disabled && !isDisabledInRules(rules.dynamic_rule.active)" :message="tooltipMessage">
              <mf-toggle v-model="item.active" :disabled="disabled || isDisabledInRules(rules.dynamic_rule.active)" class="pa-0 ml-2" hide-details />
            </tooltip>
          </template> -->
        </v-data-table>
      </div>

      <div style="flex: 1">
        <span class="digital-voucher-title">Voucher gerado</span>
        <div class="d-flex flex-row justify-space-between">
          <span class="desc" style="min-height: 44px">Voucher que o consumidor receberá</span>
        </div>
        <v-data-table class="mt-4" :headers="voucherHeaders" :items="vouchers" disable-sort disable-pagination disable-filtering hide-default-footer>
          <template v-slot:item.value="{ item }">
            <span>{{ locale(item.value, 2) | localeString(2) | currency }}</span>
          </template>
        </v-data-table>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import Tooltip from '@/modules/campanhas/gestao-ofertas-v2/views/components/Tooltip.vue'
import { localeString } from '@/config/helpers.js'
import { getVoucherType } from '@/modules/industria/helpers/getVoucherType'
import { rules } from '@/modules/campanhas/gestao-ofertas-v2/helpers/rules.js'

export default {
  name: 'DigitalVoucherTable',
  components: {
    Tooltip,
  },
  props: {
    search: {
      type: String,
      default: '',
    },
    campaign: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    isDisabledInRules: {
      type: Function,
      default: () => false,
    },
    tooltipMessage: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    locale: localeString,
    rules,
  }),
  computed: {
    productHeaders() {
      const headers = [
        {
          text: 'SKU',
          align: 'start',
          filterable: true,
          width: '6%',
          value: 'sku',
        },
        {
          text: 'EAN',
          align: 'start',
          filterable: true,
          width: '12%',
          value: 'ean',
        },
        {
          text: 'Nome',
          align: 'start',
          filterable: true,
          width: '20%',
          value: 'name',
        },
        {
          text: 'Quantidade mínima',
          align: 'center',
          width: '20%',
          value: 'trigger_amount',
        },
        // {
        //   text: 'Status',
        //   value: 'status',
        //   width: '8%',
        //   sortable: false,
        // },
      ]

      if (this.isProductsGroup) {
        headers.splice(3, 1)
      }

      return headers
    },
    products() {
      this.campaign?.dynamic_rule_offer_sales?.forEach((dynamic_rule) => {
        dynamic_rule?.trigger_products?.forEach((product) => {
          product['trigger_amount'] = dynamic_rule?.trigger_rules?.trigger_amount
        })
      })
      if (this.isProductsGroup) {
        return this.campaign?.dynamic_rule_offer_sales[0]?.trigger_products
      } else {
        return this.campaign?.dynamic_rule_offer_sales?.map((dynamic_rule) => dynamic_rule?.trigger_products[0])
      }
    },
    voucherHeaders() {
      return [
        {
          text: 'Tipo do voucher',
          align: 'start',
          value: 'type',
        },
        {
          text: 'Valor do voucher',
          align: 'start',
          value: 'value',
        },
        {
          text: 'Máx. de voucher por CPF',
          align: 'center',
          value: 'max',
        },
      ]
    },

    vouchers() {
      return [
        {
          type: this.getVoucherType(this.campaign?.dynamic_rule_offer_sales[0]?.benefits?.type || ''),
          value: this.campaign?.dynamic_rule_offer_sales[0]?.benefits?.value || 0,
          max: this.campaign?.dynamic_rule_offer_sales[0]?.trigger_rules?.maximum_per_client || 0,
        },
      ]
    },

    triggerAmount() {
      return this.campaign?.dynamic_rule_offer_sales[0]?.trigger_rules?.trigger_amount || 0
    },

    isProductsGroup() {
      return this.campaign?.dynamic_rule_offer_sales[0]?.trigger_products[0]?.group_id
    },
  },
  methods: { getVoucherType },
}
</script>

<style lang="scss" scoped>
.digital-voucher-title {
  color: $cinza-d10;
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 8px;
}

.desc {
  color: $cinza-0;
  font-size: 14px;
  width: 68%;
}

.minimum-quantity-text {
  color: $cinza-d10;
  font-size: 16px;
}

::v-deep th {
  background: $cinza-l80;
  color: $cinza-d20 !important;
  font-size: 14px;
}

::v-deep td {
  background: #f6f6f6;
}
</style>
